<template>
  <div id="newChannelCode">
    <div class="content">
      <div class="nav-bar">
        <div class="nav-bar-l">
          <img
            src="https://web-data.zmlearn.com/image/9Y2UtXePWVb3ociaEsByLV/pic_logo.png"
          />
        </div>
      </div>
      <div class="middle">
        <div class="first">
          <div class="img-box">
            <img :src="topbanPic" class="topban" />
            <div class="bottom-image"></div>
          </div>
          <div class="lesson-form-box">
            <lesson-form
              :hasBottom="false"
              type="newChannel"
              btnText=""
              btnType="1免费领课"
              :needCodeStatus="true"
              TitleText
              @showSuccessDialog="showSuccessDialog"
              :comeFrom="comeFrom"
            ></lesson-form>
          </div>
        </div>
        <img
          src="https://web-data.zmlearn.com/image/wnnxDFpBVJksMpiRnyWTxY/banner.png"
          alt=""
          style="
            background-size: contain;
            width: 94vw;
            margin-bottom: 2.4vh;
            box-sizing: border-box;
          "
          v-if="offline"
        />
        <div class="second">
          <div class="title"></div>
          <div class="sectionTab">
            <div class="tabChange">
              <div class="tabBtn1" @click="activeTab = 1"></div>
              <div class="tabBtn2" @click="activeTab = 2"></div>
            </div>
            <div class="tab tab1" v-show="activeTab == 1"></div>
            <div class="tab tab2" v-show="activeTab == 2"></div>
          </div>
          <div class="btn-box">
            <img
              src="../../assets/image/home/newListenBtn.png"
              @click="toggleDialogForm(1, '2获取0元试听')"
              class="listenBtn"
            />
            <img
              src="../../assets/image/home/newPriceBtn.png"
              @click="toggleDialogForm(2, '2获取课程价格')"
              class="priceBtn"
            />
          </div>
        </div>
        <div class="third">
          <div class="btn-box">
            <img
              src="../../assets/image/home/newListenBtn.png"
              @click="toggleDialogForm(1, '3获取0元试听')"
              class="listenBtn"
            />
            <img
              src="../../assets/image/home/newPriceBtn.png"
              @click="toggleDialogForm(2, '3获取课程价格')"
              class="priceBtn"
            />
          </div>
        </div>
        <div class="four">
          <div class="swiper-box">
            <zm-swiper
              swipeid="swipe"
              :autoplay="3000"
              :loop="true"
              effect="slide"
              ref="swiper"
            >
              <div class="swiper-slide intro1" slot="swiper-con"></div>
              <div class="swiper-slide intro2" slot="swiper-con"></div>
            </zm-swiper>
          </div>
          <div class="btn-box">
            <img
              src="../../assets/image/home/newListenBtn.png"
              @click="toggleDialogForm(1, '4获取0元试听')"
              class="listenBtn"
            />
            <img
              src="../../assets/image/home/newPriceBtn.png"
              @click="toggleDialogForm(2, '4获取课程价格')"
              class="priceBtn"
            />
          </div>
        </div>
        <div class="seventh" v-show="showBottomBtn">
          <div
            class="seventh-btn"
            @click="toggleDialogForm(1, '50元领课')"
          ></div>
        </div>
        <zm-footer style="width: 100%"></zm-footer>
        <div
          class="slide-btn"
          v-if="showDialog"
          :TitleText="TitleText"
          @click="toggleDialogForm(1, '60元领课')"
        >
          <img
            src="https://web-data.zmlearn.com/image/am1vZaqgGsTgBGeLhbsYBq/oldFixedSide.f4325583.png"
          />
        </div>
        <div class="seventh seventhFix" v-show="showBottomBtnFixed">
          <div
            class="seventh-btn"
            @click="toggleDialogForm(1, '50元领课')"
          ></div>
        </div>
      </div>
    </div>
    <div class="dialog-form" v-if="showDialogForm">
      <div class="lesson-form-content" ref="lessonFormContent">
        <div class="lesson-form-box">
          <lesson-form
            type="newChannel"
            :btnText="btnText"
            @showSuccessDialog="showSuccessDialog"
            :TitleText="TitleText"
            :needCodeStatus="true"
            :btnType="btnType"
            :comeFrom="comeFrom"
          ></lesson-form>
        </div>
        <img
          class="dialog-form-close"
          src="https://web-data.zmlearn.com/image/pMeJFjz6QKFohpr9b4wPSH/icon_close.png"
          @click="toggleDialogForm"
        />
      </div>
    </div>
    <!-- 成功弹窗 -->
    <success-dialog ref="successDialog"></success-dialog>
    <kid-success-dialog ref="kidSuccessDialog"></kid-success-dialog>
  </div>
</template>

<script>
import lessonForm from './lesson-form'
import zmFooter from '@/components/zm-footer/zm-footer'
import editBanner from '@/components/banner/banner'
import urlConfig from '@/config'
import successDialog from '@/components/success-dialog/success-dialog'
import kidSuccessDialog from '@/components/kid-success-dialog/kid-success-dialog'
import { shareMessage } from '@/assets/js/shareMessage'
import { wxfuncUrlDel } from '@/utils/util'
import api from "@/api";

export default {
  components: {
    lessonForm,
    zmFooter,
    // eslint-disable-next-line vue/no-unused-components
    editBanner,
    kidSuccessDialog,
    successDialog
  },
  data () {
    return {
      showDialog: false,
      showDialogForm: false,
      showBottomBtn: true,
      showBottomBtnFixed: true,
      activeTab: 1,
      TitleText: '',
      btnText: '',
      btnType: '',
      comeFrom: '',
      topbanPic: 'https://web-data.zmlearn.com/image/sbRmW9kvq8muQSqKgsjP6a/huanglei.png',
      offline: false
    }
  },
  created () {
    this.comeFrom = this.$route.name;
    // if (this.comeFrom && this.comeFrom == 'kid-test03') {
    //   this.topbanPic = 'https://web-data.zmlearn.com/image/sbRmW9kvq8muQSqKgsjP6a/huanglei.png'
    // } else if (this.comeFrom && this.comeFrom == 'kid-test04') {
    //   this.topbanPic = 'https://web-data.zmlearn.com/image/vhJHdGowoJMwqRoS6yawQC/zhangxiaomeng.png'
    // }
  },
  mounted () {
    api.getinfo({
      "actionName": "info",
      "activityId": 3703,
      "engineName": "common-driver"
    }).then(res => {
      if (res.data.data.params.startTimeStamp <= res.data.data.params.currentTimeStamp && res.data.data.params.currentTimeStamp <= res.data.data.params.endTimeStamp) {
        this.offline = true;
        this.comeFrom = this.$route.name;
        if (this.offline) {
          if (this.comeFrom && this.comeFrom == 'kid-test03') {
            this.topbanPic = 'https://web-data.zmlearn.com/image/8oPtRrHuDkoer6zNDz1A8z/1.png'
          } else if (this.comeFrom && this.comeFrom == 'kid-test04') {
            this.topbanPic = 'https://web-data.zmlearn.com/image/m3mNKrPoryUbJk54rYSXxD/2.png'
          }
        }
      }
    });
    wxfuncUrlDel(this)
    this.$nextTick(() => {
      window.addEventListener('scroll', this.checkPosition, false)
      this.checkPosition()
      shareMessage({
        title: '掌门少儿',
        desc: '免费领取价值398元试听课',
        imgUrl: 'https://activity-static.zmlearn.com/m/zmsr.png'
      })
    })

  },
  destroyed () {
    window.removeEventListener('scroll', this.checkPosition)
  },
  methods: {
    jumpZhichi () {
      window.location.href =
        'https://www.sobot.com/chat/h5/index.html?sysNum=bfc2a73dae7342ada3d886355e2b10c3'
    },
    jumpPeilian () {
      window.location.href = 'https://m.zmpeilian.com'
    },
    jumpDetail () {
      const index = this.$refs.swiper.mySwiper.realIndex
      let path = ''
      // if (index == 0) {
      //   path = '/course-math'
      // } else if (index == 1) {
      //   path = '/course-chinese'
      // } else if (index == 2) {
      //   path = '/course-study'
      // }
      switch (index) {
        case 0:
          path = '/course-math'
          break
        case 1:
          path = '/course-chinese'
          break
        case 2:
          path = '/course-study'
          break
      }

      const query = this.$route.query
      delete query.ABTestUrl
      const params = JSON.stringify(query)
        .replace(/[\"\{\}]/g, '')
        .replace(/\:/g, '=')
        .replace(/\,/g, '&')
      path = path + '?' + params
      this.$router.push(path)
    },
    toggleDialogForm (type, btn) {
      this.showDialogForm = !this.showDialogForm
      if (btn) {
        this.btnType = btn
        switch (btn) {
          case '2获取0元试听':
            _hmt.push(['_trackEvent', '获取0元试听', '少儿课程', this.$route.name]);
            break
          case '2获取课程价格':
            _hmt.push(['_trackEvent', '获取课程价格', '少儿课程', this.$route.name]);
            break
          case '3获取0元试听':
            _hmt.push(['_trackEvent', '获取0元试听', '少儿特色', this.$route.name]);
            break
          case '3获取课程价格':
            _hmt.push(['_trackEvent', '获取课程价格', '少儿特色', this.$route.name]);
            break
          case '4获取0元试听':
            _hmt.push(['_trackEvent', '获取0元试听', '少儿师资', this.$route.name]);
            break
          case '4获取课程价格':
            _hmt.push(['_trackEvent', '获取课程价格', '少儿师资', this.$route.name]);
            break
          case '50元领课':
            _hmt.push(['_trackEvent', '0元领课', '少儿底部导航', this.$route.name]);
            break
          case '60元领课':
            _hmt.push(['_trackEvent', '0元领课', '少儿侧边栏', this.$route.name]);
            break
        }
      }
      if (type == 1) {
        this.btnText = '免费领课'
        this.TitleText = '<div style="color:#333;font-size:0.53rem;font-weight:normal;font-family:"PingFangSC-Medium">填写信息免费领取试听课</div>'
      } else {
        this.btnText = '免费获取价格'
        this.TitleText = '<div style="color:#333;font-size:0.53rem;font-weight:normal;padding:0 40px;font-family:"PingFangSC-Regular">填写报名后会有课程顾问致电告知您课程价格</div>'
      }
    },
    checkPosition () {
      if (window.scrollY < 350) {
        this.showDialog = false
        this.showBottomBtnFixed = false
      } else if (window.scrollY > 350 && window.scrollY < 1570) {
        this.showDialog = true
        this.showBottomBtnFixed = true
      } else if (window.scrollY > 1570) {
        this.showDialog = true
        this.showBottomBtn = true
        this.showBottomBtnFixed = false
      }
    },
    showSuccessDialog (result) {
      this.showDialogForm = false
      switch (result.type) {
        case 'kidSuccessDialog':
          this.$refs.kidSuccessDialog.postFormSuccess(result.mobile)
          break
        case 'successDialog':
          this.$refs.successDialog.postFormSuccess()
          break
        default:
          console.log('异常~')
      }
    }
  }
}
</script>
<style lang="scss"  >
#newChannelCode {
  .four {
    .swiper-container {
      width: 100%;
      height: 100%;
      z-index: 0;
      .swiper-pagination {
        bottom: px2rem(50);
        .swiper-pagination-bullet {
          background: #ffcf97;
          transition: all 0.25s ease;
        }
        .swiper-pagination-bullet-active {
          width: px2rem(50);
          height: px2rem(16);
          border-radius: px2rem(30);
          background: #ffad10;
          transition: all 0.25s ease;
        }
      }
    }
    .swiper-slide {
      height: px2rem(612);
      vertical-align: bottom;
      background-size: contain !important;
    }
  }
  .first {
    .swiper-slide {
      img {
        height: px2rem(394);
        width: 100%;
        vertical-align: bottom;
      }
    }
    .lesson-form-box {
      width: px2rem(720) !important;
      height: px2rem(1000) !important;
      padding-top: 1.5vh;
      .lesson-form {
        width: px2rem(720);
        height: px2rem(1000);
        background: url('../../assets/image/home/newFormBg2.png') no-repeat
          center;
        background-size: contain;
        box-shadow: none;
        .form-content {
          text-align: center;
          h2 {
            margin-top: 0.4rem;
            display: inline-block;
            width: px2rem(443) !important;
            height: px2rem(40) !important;
            background: url('https://web-data.zmlearn.com/image/347LcRV48YRyHC6gD8s7EG/receive.png')
              no-repeat center !important;
            background-size: contain !important;
          }
          .form-item {
            margin: px2rem(20) auto px2rem(20);
            height: px2rem(110);
          }
          .flex-item {
            position: relative;
            box-sizing: border-box;
            display: inline-block;
            display: flex;
            justify-content: space-between;
            padding: 0 px2rem(60);
            height: px2rem(110);
            width: px2rem(720);
            .arrow {
              position: absolute;
              display: inline-block;
              width: px2rem(25);
              height: px2rem(15);
              background: url('../../assets/image/home/newFromArrow.png')
                no-repeat center !important;
              background-size: contain !important;
              right: px2rem(50);
              top: px2rem(50);
            }
            .grade-arrow {
              right: 4.7rem !important;
            }
            .subject-arrow {
              right: px2rem(70);
            }
          }
          .grade,
          .subject,
          input {
            font-size: 95%;
            height: px2rem(110);
            background: #fffbf1;
            border: 1px #ffce4f solid;
            border-radius: px2rem(110);
            text-indent: px2rem(30);
            color: #9a8d7f;
            &::-webkit-input-placeholder {
              color: #9a8d7f;
            }
            &::-moz-placeholder {
              color: #9a8d7f;
            }
          }
          .grade {
            width: 55% !important;
            position: relative;
            width: px2rem(295);
            height: px2rem(110);
            color: #603f1d;
          }
          .subject {
            width: 44% !important;
            position: relative;
            width: px2rem(295);
            height: px2rem(110);
            color: #603f1d;
          }
        }
        .form-protocol {
          .checkoutImg {
            width: px2rem(27);
            height: px2rem(27);
            margin-right: px2rem(20);
          }
          .form-protocol-text {
            .high-light {
              color: #ff6e35;
            }
          }
        }
        .zm-btn {
          width: px2rem(630);
          height: px2rem(150);
          background: url('../../assets/image/home/newFormBtn.png') no-repeat
            center;
          background-size: cover;
          line-height: px2rem(170);
          margin: px2rem(20) auto;
        }
        .info {
          margin: 0px;
          padding-bottom: px2rem(50);
        }
        .get-identify-code {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: px2rem(50);
          border-radius: px2rem(55);
          background-color: rgb(255, 103, 82);
          width: px2rem(165);
          height: px2rem(55);
          font-size: px2rem(24);
          line-height: px2rem(55);
          text-align: center;
        }
      }
    }
  }
  .bottom-area {
    padding: 0;
  }
  .dialog-form {
    .lesson-form {
      .form-content {
        .flex-item {
          position: relative;
          .arrow {
            position: absolute;
            display: inline-block;
            width: px2rem(25);
            height: px2rem(15);
            background: url('../../assets/image/home/newPopFromArrow.png')
              no-repeat center !important;
            background-size: contain !important;
            right: px2rem(50);
            top: px2rem(50);
          }
          .grade-arrow {
            top: px2rem(40);
            right: 3.9rem;
          }
          .subject-arrow {
            top: px2rem(40);
            right: px2rem(20);
          }
        }
        .grade,
        .subject,
        input {
          font-size: 95%;
          background: #eee;
          border: none;
          border-radius: px2rem(10);
          text-indent: px2rem(30);
          color: #202020;
          &::-webkit-input-placeholder {
            color: #999;
          }
          &::-moz-placeholder {
            color: #999;
          }
        }
        .grade {
          width: 55% !important;
          position: relative;
          color: #202020;
        }
        .subject {
          width: 44% !important;
          position: relative;
          color: #202020;
        }
      }
      .form-protocol {
        .checkoutImg {
          width: px2rem(27);
          height: px2rem(27);
          margin-right: px2rem(20);
        }
        .form-protocol-text {
          .high-light {
            color: #ff6e35;
          }
        }
      }
      .zm-btn {
        position: relative;
        width: px2rem(450);
        height: px2rem(106);
        background: url('../../assets/image/home/newPopFormBtnBg.png') no-repeat
          center;
        background-size: cover;
        margin: px2rem(20) auto;
        span {
          position: absolute;
          transform: translate(-50%, -50%);
          left: 50%;
          top: 50%;
          height: px2rem(106);
          line-height: px2rem(90);
          font-size: px2rem(35);
          text-align: center;
        }
      }
      .get-identify-code {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: px2rem(30);
        border-radius: px2rem(50);
        background-color: rgb(255, 103, 82);
        width: px2rem(165);
        height: px2rem(50);
        font-size: px2rem(24);
        line-height: px2rem(50);
        text-align: center;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// @import './../../styles/mixin.scss';

#newChannelCode {
  position: relative;
  .content {
    width: px2rem(750);
    background-color: #fff4d5;
    .nav-bar {
      width: px2rem(750);
      height: px2rem(62);
      z-index: 2;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nav-bar-l {
        margin: 0 auto;
        img {
          width: px2rem(142);
        }
      }
      .nav-bar-r {
        display: flex;
        justify-content: space-between;
        width: px2rem(225);
        margin-right: px2rem(10);
        &:hover,
        &:active {
          text-decoration: none;
        }
        img {
          width: px2rem(30);
          height: px2rem(30);
        }
        h4 {
          display: inline-block;
          font-size: px2rem(28);
          color: #f54f50;
          letter-spacing: 0;
          line-height: px2rem(28);
        }
      }
    }
    .middle {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      max-width: px2rem(750);
      margin: 0 auto;
      .first {
        .img-box {
          width: px2rem(750);
          height: px2rem(530);
          overflow: hidden;
          z-index: 1;
          position: relative;
          .topban {
            width: px2rem(750);
            height: px2rem(555);
            object-fit: cover;
          }
          .bottom-image {
            width: px2rem(750);
            height: px2rem(46);
            background: url('https://web-data.zmlearn.com/image/jmovVfsP7SfcrKx9BWLUjn/banner_bottom.png')
              no-repeat center;
            background-size: cover;
            position: absolute;
            bottom: px2rem(-1);
            z-index: -100;
          }
        }
        .lesson-form-box {
          position: relative;
          margin-top: -1.1rem;
          margin-bottom: px2rem(40);
          z-index: 1;
        }
      }
      .second {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: px2rem(70);
        .title {
          background: url('../../assets/image/home/newSection1Title.png')
            no-repeat center;
          background-size: contain;
          width: px2rem(669);
          height: px2rem(38);
          margin-bottom: px2rem(20);
        }
        .sectionTab {
          position: relative;
          top: 0;
          left: 0;
          margin-bottom: px2rem(20);
          .tabChange {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            width: px2rem(690);
            height: px2rem(68);
            div {
              flex: 1;
              height: px2rem(68);
            }
          }
          .tab1 {
            width: px2rem(690);
            height: px2rem(554);
            background: url('https://web-data.zmlearn.com/image/tGnM7gir6LT8V1n56ox3Wa/swiper-chinese.png')
              no-repeat 50%;
            background-size: contain;
          }
          .tab2 {
            width: px2rem(690);
            height: px2rem(554);
            background: url('https://web-data.zmlearn.com/image/7AdyhrpAJHiJaPyExqqrDp/swiper-math.png')
              no-repeat center;
            background-size: contain;
          }
        }
      }
      .third {
        background: url('../../assets/image/home/newSection2.png') no-repeat top
          center;
        background-size: contain;
        width: px2rem(687);
        height: px2rem(980);
        padding-top: px2rem(820);
        box-sizing: border-box;
      }
      .four {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: url('https://web-data.zmlearn.com/image/etB8v73SvycX2989wtiYky/newSection3Title.4234bdd9.png')
          no-repeat top center;
        background-size: contain;
        width: px2rem(687);
        padding-top: px2rem(380);
        margin-bottom: px2rem(30);
        .swiper-box {
          height: px2rem(460);
          width: 100%;
          .intro1 {
            width: 100%;
            background: url('../../assets/image/home/newSectionBan1.png')
              no-repeat top center;
          }
          .intro2 {
            width: 100%;
            background: url('../../assets/image/home/newSectionBan2.png')
              no-repeat top center;
          }
        }
      }
      .btn-box {
        width: 100%;
        display: flex;
        justify-content: space-around;
        .listenBtn,
        .priceBtn {
          width: px2rem(325);
          height: px2rem(90);
        }
        .listenBtn {
          margin-right: px2rem(15);
        }
      }
      .slide-btn {
        position: fixed;
        z-index: 99;
        top: 50%;
        margin-top: 2rem;
        right: 0;
        transition: all 0.5s ease;
        display: block;
        transform: translateZ(0);
        img {
          display: block;
          width: px2rem(172);
          height: px2rem(125);
        }
      }
      .seventh {
        overflow: hidden;
        height: px2rem(148);
        .seventh-btn {
          width: px2rem(750);
          height: px2rem(148);
          bottom: 0;
          left: 0;
          background: url('https://web-data.zmlearn.com/image/6c9U6MJreoG3T1Xq4vAtYJ/newFixedFooter.56f4df82.png')
            no-repeat center;
          background-size: contain;
          .btn-box {
            .btn-left {
              display: inline-block;
              width: px2rem(345);
              height: px2rem(90);
            }
            .btn-right {
              display: inline-block;
              width: px2rem(345);
              height: px2rem(90);
            }
          }
        }
        &.seventhFix {
          position: fixed;
          overflow: hidden;
          height: px2rem(148);
          bottom: 0;
          .seventh-btn {
            width: px2rem(750);
            height: px2rem(148);
            bottom: 0;
            left: 0;
            background: url('https://web-data.zmlearn.com/image/6c9U6MJreoG3T1Xq4vAtYJ/newFixedFooter.56f4df82.png')
              no-repeat center;
            background-size: contain;
            .btn-box {
              .btn-left {
                display: inline-block;
                width: px2rem(345);
                height: px2rem(90);
              }
              .btn-right {
                display: inline-block;
                width: px2rem(345);
                height: px2rem(90);
              }
            }
          }
        }
      }
    }
  }
  .dialog-form {
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    .lesson-form-content {
      position: fixed;
      width: px2rem(664);
      height: px2rem(776);
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .lesson-form-box {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      }
      .dialog-form-close {
        position: absolute;
        bottom: px2rem(-150);
        display: block;
        width: px2rem(75);
        height: px2rem(75);
        margin-left: px2rem(295);
        margin-top: px2rem(75);
      }
    }
  }
  .lesson-form-box {
    width: px2rem(664);
    // height: px2rem(742);
    margin: 0 auto;
  }
}
</style>
